import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal } from "@/components/kit";
import GiveForm from "./GiveForm";
import ThankYou from "./ThankYou";

// Orchestrates give form -> thank you. Posts through the SAME Square path as dues.
export default function GiveModal({ campaign, prefill, onClose, onDone }) {
  const [done, setDone] = useState(null);

  const submit = async (payload) => {
    const r = await api.post("/donations/pay", payload);
    const st = r.data.status;
    if (st === "PAID") toast.success("Thank you — your gift was received");
    else if (st === "SIMULATED") toast.message("Simulated gift recorded (not counted as paid)");
    else { toast.error(r.data.error || `Payment ${st}`); const err = new Error(st); err.handled = true; throw err; }
    setDone(r.data.donation);
    onDone && onDone();
  };

  return (
    <Modal open onClose={onClose} title={done ? "Thank you" : `Give to ${campaign.give_label || campaign.title}`}>
      {done
        ? <ThankYou donation={done} onDone={onClose} />
        : <GiveForm campaign={campaign} prefill={prefill} onDonate={submit} />}
    </Modal>
  );
}
